export enum AssigneeRoleType {
    CredentialingSpecialist = 1,
    ComplianceLiaison = 2,
    Unknown = 3
}
